/**
 * Konstanten, die einem Element mit hinzugefügt werden können (z.B. als a11yId im EventButtonContext) und diesen so eindeutig machen.
 * Durch diese Eindeutigkeit lässt sich nach dem Rendern die eigentliche Id des Buttons im DOM ermitteln und anschließend
 * weiterverarbeiten z.B. für das Fokus-Konzept
 */
export const ModelElements = {
	erneutGenerierenButton: "erneutGenerierenButton"
};

export const Descriptors = {
	accessibilityPage: { page: "accessibility" },
	emptyPortalPage: { page: "emptyPortal" }
};

export const HeaderKeys = {
	marker: "mf-marker"
} as const;

export const UrlParameters = {
	marker: "marker"
};
